import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBearerToken } from '@features/authentication/authFunctions';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { Article } from '@api/types/Article';



export const authApi = createApi({
	reducerPath: 'authApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.DATA_API_URL}/`,
		prepareHeaders: async(headers) => {
			headers.set('AuthToken', getBearerToken());
			return headers;
		},
	}),
	tagTypes: [
		'artcles',
	],
	endpoints: (builder) => ({
		getArticles: builder.query<Article[], { country: LanguageEnum }>({
			query: ({ country }) => ({
				url: 'Article/GetList',
				params: { country }
			}),
			providesTags: ['artcles']
		}),

		postArticle: builder.mutation<void,Article>({
			query: (article) => ({
				url: 'Article/PostArticle',
				method: 'POST',
				body: article
			}),
			invalidatesTags: ['artcles'],
		}),
	}),
});


export const {
	useGetArticlesQuery,
	usePostArticleMutation } = authApi;